// Cell formatters for the booking tables (JQBookings, ZenBookings).
//
// Both tables use the same dense language — paired two-line cells, nothing wraps,
// long free text truncates — so they must format their values identically. These
// lived inside JQBookings until Zen's table adopted the same layout.

// Two-digit year and a zero-padded day, so dates occupy a fixed width and stack
// in a column. "26 Sept 2027" wrapping to three lines is what made rows ragged.
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, '0');
  const mon = d.toLocaleDateString('en-MY', { month: 'short' }).slice(0, 3);
  return `${day} ${mon} ${String(d.getFullYear()).slice(2)}`;
};

// The money columns carry their own "RM" in the header instead of on every row.
// An em dash for absent values, never a 0.00 that was never collected.
export const formatAmount = (amount) => {
  if (amount == null || amount === '') return '—';
  return parseFloat(amount).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
